import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { Bookmark, Trash2 } from 'lucide-react';

export const saveTemplate = async (kind, name, data) => {
  try {
    await api.post('/templates', { kind, name, data });
    toast.success('Guardado en tus plantillas');
    return true;
  } catch {
    toast.error('No se pudo guardar la plantilla');
    return false;
  }
};

export const TemplateMenu = ({ kind, label, onApply, getData, testid, applyLabel = 'Usar' }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [name, setName] = useState('');
  const ref = useRef(null);

  const load = () => api.get(`/templates?kind=${kind}`).then(r => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { if (open) load(); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  const save = async () => {
    if (!name.trim()) return;
    if (await saveTemplate(kind, name.trim(), getData())) { setName(''); load(); }
  };
  const remove = async (id) => {
    await api.delete(`/templates/${id}`).catch(() => {});
    load();
  };

  return (
    <div className="relative" ref={ref}>
      <button type="button" onClick={() => setOpen(!open)} data-testid={`${testid}-toggle`}
        className="inline-flex items-center gap-2 px-3 py-2 border border-stilo-ink/15 text-xs tracking-[0.12em] uppercase hover:border-stilo-ink">
        <Bookmark className="w-3.5 h-3.5" strokeWidth={1.5} /> {label}
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-2 w-80 bg-stilo-bg border border-stilo-ink/15 shadow-lg p-4" data-testid={`${testid}-menu`}>
          {getData && (
            <div className="flex gap-2 mb-4">
              <input value={name} onChange={e => setName(e.target.value)} onKeyDown={e => e.key === 'Enter' && save()}
                placeholder="Nombre de la plantilla" className="flex-1 border border-stilo-ink/15 p-2 text-sm bg-white" data-testid={`${testid}-name`} />
              <button onClick={save} className="px-3 bg-stilo-ink text-stilo-bg text-xs uppercase tracking-[0.12em]" data-testid={`${testid}-save`}>Guardar</button>
            </div>
          )}
          {items.length === 0 && <p className="text-xs text-stilo-ink3">Aún no tienes nada guardado.</p>}
          <ul className="max-h-64 overflow-auto divide-y divide-stilo-ink/10">
            {items.map(t => (
              <li key={t.id} className="flex items-center gap-2 py-2" data-testid={`${testid}-item`}>
                <span className="flex-1 text-sm truncate">{t.name}</span>
                <button onClick={() => { onApply(t.data); setOpen(false); }} className="text-xs underline hover:text-stilo-gold" data-testid={`${testid}-apply`}>{applyLabel}</button>
                <button onClick={() => remove(t.id)} className="text-stilo-ink3 hover:text-stilo-terra" aria-label="Borrar" data-testid={`${testid}-delete`}><Trash2 className="w-3.5 h-3.5" /></button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
